import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Box, Checkbox, Chip, FormHelperText, ListItemText, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { TimePicker } from "@mui/x-date-pickers";
import DateRangePicker from 'rsuite/esm/DateRangePicker';
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import ReactQuill from 'react-quill'; // Import ReactQuill for the message2 field
import 'react-quill/dist/quill.snow.css';
import Address_Google_Map_Field from "./Address_Google_Map_Field";
import MapWithMarker from "../Maps/MapWithMarker";

export default function FormFields({
  label,
  name,
  value,
  btn,
  onChange,
  placeholder,
  error,
  width = true,
  helperText,
  type, // Can be 'text', 'password', 'select', 'date', 'time', or 'autocomplete'
  options, // For select/autocomplete field options
  handleAddClick,
  handleRemoveClick,
  optionalCname,
  required,
  file,
  uploadedFile,
  multiple, readOnly,
  disable,
  minDate,
  maxDate
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { beforeToday } = DateRangePicker;

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (event) => event.preventDefault();

  const handleOpenAutocomplete = () => {
    setOpen(true);
    if (!options.length) {
      setLoading(true);
      // Simulate async data loading
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const handleCloseAutocomplete = () => {
    setOpen(false);
  };

  const [timeValue, setTimeValue] = useState(
    value ? dayjs(value, "HH:mm:ss") : null
  );

  useEffect(() => {
    if (value) {
      if (type === "time") {
        setTimeValue(dayjs(value, "HH:mm:ss")); // Parse time format correctly
      } else if (type === "date") {
        setTimeValue(dayjs(value));
      }
    }
  }, [value, type]);

  const handleSelectChange = (e) => {
    const { value } = e.target;
    onChange({
      target: {
        name,
        value
      }
    });
  };

  const formatIndianMobile = (val = "") => {
    // Remove everything except digits
    let digits = val.replace(/\D/g, "");

    // Remove leading 91 if pasted
    if (digits.startsWith("91")) {
      digits = digits.slice(2);
    }

    // Limit to 10 digits
    digits = digits.slice(0, 10);

    if (digits.length > 5) {
      return `+91 ${digits.slice(0, 5)}-${digits.slice(5)}`;
    }

    return `+91 ${digits}`;
  };
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };


  return (
    <>
      {type === "select" ? (
        <FormControl variant="outlined" fullWidth={width} size="small" className={optionalCname} error={error}>
          <InputLabel>{label}</InputLabel>
          <Select
            name={name}
            value={value || ''}
            onChange={(e) => handleSelectChange(e)}
            label={label}
            required={required}
            multiple={multiple}
            error={error}
            readOnly={readOnly}
          >

            {disable ? options?.map((option, index) => {
                const isObject = typeof option === 'object' && option !== null;
                const optionValue = isObject ? option.value : option;
                const optionLabel = isObject ? option.label : option;

                return (
                  <MenuItem key={index + 1} value={optionValue} disabled={disable}>
                    {optionLabel}
                  </MenuItem>
                );

            }) : options?.map((option, index) =>{
              const isObject = typeof option === 'object' && option !== null;
                const optionValue = isObject ? option.value : option;
                const optionLabel = isObject ? option.label : option;

                return (
                  <MenuItem key={index + 1} value={optionValue} >
                    {optionLabel}
                  </MenuItem>
                );
            })}
          </Select>
          <FormHelperText>{helperText}</FormHelperText>
        </FormControl>
      ) : type === "multi-select-checkbox" ? (
  <FormControl
    variant="outlined"
    sx={{width:'300px'}}
    size="small"
    className={optionalCname}
  >
    <InputLabel>{label}</InputLabel>

    <Select
      name={name}
      multiple
      value={value || []}
      onChange={(e) => handleSelectChange(e)}
      label={label}
      required={required}
      readOnly={readOnly}
      renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
      MenuProps={MenuProps}
    >
      {options?.map((option, index) => (
        <MenuItem key={index} value={option} disabled={disable}>
          <Checkbox checked={value?.indexOf(option) > -1} />
          <ListItemText primary={option} sx={{whiteSpace:'normal'}}/>
        </MenuItem>
      ))}
    </Select>
  </FormControl>): type === "password" ? (
       <TextField
  label={label}
  name={name}
  type={showPassword ? "text" : "password"}
  value={value}
  onChange={onChange}
  error={error}
  helperText={helperText}
  size="small"
  fullWidth
  required={required}
  className={optionalCname}
  InputProps={{
    readOnly,
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          onClick={handleClickShowPassword}
          onMouseDown={handleMouseDownPassword}
          edge="end"
        >
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    ),
  }}
/>

      ) : type === "date" ? (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      label={label}
      value={timeValue}
      readOnly={readOnly}

      /* ✅ MIN & MAX DATE */
      minDate={minDate ? dayjs(minDate) : undefined}
      maxDate={maxDate ? dayjs(maxDate) : undefined}

      /* ✅ DISABLE DATES OUTSIDE RANGE */
      shouldDisableDate={(date) => {
        if (minDate && date.isBefore(dayjs(minDate), "day")) return true;
        if (maxDate && date.isAfter(dayjs(maxDate), "day")) return true;
        return false;
      }}

      onChange={(newValue) => {
        setTimeValue(newValue);
        onChange({
          target: {
            name,
            value: newValue ? newValue.toISOString() : null,
          },
        });
      }}

      /* ✅ ERROR + HELPER TEXT */
      slotProps={{
        textField: {
          size: "small",
          error: Boolean(error),
          helperText: helperText,
          required,
          fullWidth: width,
          className: optionalCname,
        },
      }}

      sx={{
        [`& .MuiInputBase-input`]: {
          padding: "8px 14px",
        },
        ["& .MuiFormLabel-root"]: { top: "0px" },
      }}
    />
  </LocalizationProvider>
      ) : type === "time" ? (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            label={label}
            name={name}
            sx={{
              [`& .MuiInputBase-input`]: {
                padding: "8px 14px",
              },
              ["& .MuiFormLabel-root"]: { top: "-8px" },
            }}
            className={optionalCname}
            value={timeValue}
            readOnly={readOnly}
            onChange={(newValue) => {
              setTimeValue(newValue);
              onChange({
                target: {
                  name,
                  value: newValue?.format("HH:mm:ss"), // Return the time in the correct format
                },
              });
            }}
          />
        </LocalizationProvider>
      ) : type === "date-range" ? (
        <DateRangePicker
          value={value}
          onChange={(value) => onChange({ target: { name, value } })}
          format={"MM/dd/yyyy"}
          placeholder={label}
          showOneCalendar
          size="lg"
          shouldDisableDate={beforeToday()}
          className={optionalCname}
        />
      ) : type === "message" ? (
        <Box sx={{ width: "100%" }}>
          <ReactQuill
            value={value || ""}
            onChange={(newValue) => {
              onChange({
                target: {
                  name,
                  value: newValue,
                },
              });
            }}
            placeholder="Type your message here..."
            theme="snow" // Use 'snow' theme
            style={{ minHeight: 150, width: '100%' }} // Optional: You can set the height of the editor
          />
        </Box>
      ) : type === "autocomplete" ? (
        <Autocomplete
          sx={{ minWidth: "280px" }}
          open={open}
          onOpen={handleOpenAutocomplete}
          onClose={handleCloseAutocomplete}
          options={[...new Set(options)]}
          isOptionEqualToValue={(option, value) => option === value}
          getOptionLabel={(option) => option}
          loading={loading}
          required={required}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              size="small"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          value={value}
          onChange={(event, newValue) => {
            onChange({ target: { name, value: newValue } });
          }}
        />
      ) : type === 'address' ?
        <Address_Google_Map_Field
          label={label}
          value={value ? value : ""} // Ensure value is set if it exists
          onChange={(data) => {
            onChange({ target: { name, value: data } });
          }}
          cName={optionalCname}
          multiple={multiple}
          readOnly={readOnly}
        />
        : type === 'file' ? uploadedFile ? (
          <>
            <p>File already uploaded: <a href={uploadedFile} target="_blank" rel="noopener noreferrer">file</a></p>

            <TextField
              label={label}
              name={name}
              value={value}
              onChange={onChange}
              placeholder={placeholder}
              autoComplete="off"
              error={error}
              helperText={helperText}
              fullWidth={width}
              type='file'
              size="small"
              className={optionalCname}
              required={false}
            />
          </>
        ) : (<TextField
          label={label}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete="off"
          error={error}
          helperText={helperText}
          fullWidth={width}
          type='file'
          size="small"
          className={optionalCname}
          required={required}
        />) : type === 'phone_number' ? (<TextField
          hiddenLabel
          variant="outlined"
          name={name}
          value={value}
          placeholder="+91 XXXXX-XXXXX"
          className={optionalCname}
          size="small"
          error={error}
          helperText={helperText}
          disabled={disable}
          inputProps={{
            inputMode: "numeric",
            maxLength: 15, // +91 12345-67890
            readOnly,
          }}
          onFocus={(e) => {
            if (!e.target.value) {
              onChange({
                target: { name, value: "+91 " },
              });
            }
          }}
          onChange={(e) => {
            const formatted = formatIndianMobile(e.target.value);

            onChange({
              target: {
                name,
                value: formatted,
              },
            });
          }}
        />
        )
          : type ? (
            <TextField
              label={label}
              name={name}
              value={value}
              onChange={onChange}
              placeholder={placeholder}
              autoComplete="off"
              error={error}
              helperText={helperText}
              fullWidth={width}
              type={type}
              size="small"
              className={optionalCname}
              required={required}
              inputProps={{ readOnly: readOnly }}
            />
          ) : (
            <Box className="label_group">
              <Typography className="label">{label}</Typography>
              {(btn === "Add" || btn === "add") ? (
                <Link className="btn-link" onClick={handleAddClick}>
                  {btn}
                </Link>
              ) : (btn === "Remove" || btn === "remove") && (
                <Link className="btn-link remove" onClick={handleRemoveClick}>
                  {btn}
                </Link>
              )}
            </Box>
          )}
    </>
  );
}
